import * as React from "react";
import Grid from "@material-ui/core/Grid";
import FileViewTable from "../../components/DocumentNotApproveModal/FileViewTable.js";
import { ContractMomService } from "../../services";

const MomDetailDeleteMOM = ({ transaction_no }) => {
  const [attachments, SetAttachments] = React.useState([]);

  const handleOnInintial = async () => {
    ContractMomService.getAttachments(transaction_no)
        .then((response) => {
          console.log("getCommitteeAttachments");
          console.log(response);
          if (response.isSuccess) {
            let dataresponse = response.resData
              .filter((p) => p.file_category === "C0")
              .map((item) => {
                if (item.isActive === null) {
                  item.isActive = true;
                }
                return item;
              });
            console.log(dataresponse);
            SetAttachments(dataresponse);
          }
        })
        .catch(() => {
        });
  };

  React.useEffect(() => {
    handleOnInintial();
  }, [transaction_no]);

  return (
      <Grid container spacing={2}>
        
        <Grid item xs={12} className="sp-table-container">
            <FileViewTable items={attachments} readonly={true} textAlign="text-center"></FileViewTable>
        </Grid>
      </Grid>
  );
};

export default MomDetailDeleteMOM;
